import { atom } from "jotai";
import { nodesAtom } from "./nodesAtom";

export const removeEphemeralEmbedNodesSetter = atom(null, (get, set) => {
  const nodes = get(nodesAtom);
  const filteredNodes = nodes.filter((node) => node.type !== "embed-ephemeral");
  set(nodesAtom, filteredNodes);
});

removeEphemeralEmbedNodesSetter.debugLabel = "removeEphemeralEmbedNodesSetter";
